import { Card } from 'react-bootstrap';

import { Status } from '../shared/Status';
import { WrapperOrchestrator } from '../shared/styles';
import { useSelectedWorkflowStep } from '../../hooks/useSelectedWorkflowStep';
import { StepTrackerLine } from './components/StepTrackerLine/StepTrackerLine';
import { StatusDates } from '../shared/StatusDates';
import { ModalOrchestratorSupportTool } from '../ModalOrchestratorSupportTool/ModalOrchestratorSupportTool';
import { RolesGuard } from '@domains/user';
import { UserRoles } from '@domains/user/utils/roles';

export const OrchestratorStep = () => {
  const { step } = useSelectedWorkflowStep();

  if (!step) {
    return (
      <WrapperOrchestrator>
        <Card>
          <Card.Body>No hay paso seleccionado.</Card.Body>
        </Card>
      </WrapperOrchestrator>
    );
  }

  const getUpdatedAt = (status: string, endAt?: string) => {
    if (status === 'IN_PROGRESS') {
      return new Date().toISOString();
    }

    return endAt;
  };

  return (
    <WrapperOrchestrator style={{ height: '100%' }}>
      <Card className="h-100 d-flex flex-column">
        <Card.Header className="w-100 flex-shrink-0">
          <div className="d-flex flex-column gap-2 w-100">
            <div className="d-flex justify-content-between">
              <div className="d-flex gap-2 align-items-center">
                <Status status={step.status} />
                <div>{step.name}</div>
                <RolesGuard roles={[UserRoles.IDM_TECH]}>
                  <ModalOrchestratorSupportTool />
                </RolesGuard>
              </div>
            </div>
            <StatusDates
              status={step.status}
              startAt={step.start_at}
              endAt={step.end_at}
              updatedAt={getUpdatedAt(step.status, step.end_at)}
            />
          </div>
        </Card.Header>

        <Card.Body style={{ height: 'calc(100% - 115px)' }}>
          {step.responses.length > 0 ? (
            <StepTrackerLine />
          ) : (
            <div className="p-3">No hay procesos para este orquestador.</div>
          )}
        </Card.Body>
      </Card>
    </WrapperOrchestrator>
  );
};
